var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex",
      staticStyle: {
        height: "50%",
        "justify-content": "center",
        "flex-wrap": "wrap",
      },
    },
    [
      _c(
        "div",
        { staticClass: "baseData" },
        _vm._l(_vm.baseData, function (item, index) {
          return _c("div", { key: index, staticClass: "baseDataList" }, [
            _c("div", { staticClass: "baseData_name" }, [
              _c("img", {
                directives: [
                  {
                    name: "lazy",
                    rawName: "v-lazy",
                    value: item.url,
                    expression: "item.url",
                  },
                ],
                staticStyle: { height: "100%" },
              }),
            ]),
            _c(
              "div",
              {
                staticClass: "baseData_fName",
                staticStyle: { "text-align": "center" },
              },
              [
                _c("i", { staticClass: "baseData_num" }, [
                  _vm._v(_vm._s(item.num)),
                ]),
                _c("span", { staticClass: "baseData_unit" }, [
                  _vm._v(_vm._s(item.unit)),
                ]),
                _c("p", [_vm._v(_vm._s(item.name))]),
              ]
            ),
          ])
        }),
        0
      ),
      _c("div", { staticClass: "mainContent flex" }, [
        _vm.imgList.length > 0
          ? _c(
              "div",
              { staticClass: "swiper" },
              [
                _c(
                  "swiper",
                  {
                    staticClass: "imgcase",
                    attrs: { options: _vm.swiperOption },
                  },
                  _vm._l(_vm.imgList, function (item, index) {
                    return _c("swiper-slide", { key: index }, [
                      _c("img", {
                        directives: [
                          {
                            name: "lazy",
                            rawName: "v-lazy",
                            value: _vm.$config.imgIp + item.logo,
                            expression: "$config.imgIp + item.logo",
                          },
                        ],
                        staticClass: "pic",
                        on: {
                          click: function ($event) {
                            return _vm.previewClick(_vm.imgList, index)
                          },
                        },
                      }),
                      _c("p", { staticClass: "name" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                    ])
                  }),
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.imgList.length > 2
          ? _c("div", { staticClass: "swiper-button-next" })
          : _vm._e(),
        _vm.imgList.length > 2
          ? _c("div", { staticClass: "swiper-button-prev" })
          : _vm._e(),
      ]),
      _c("div", { ref: "chart", staticClass: "chart" }),
      _c("div", { staticClass: "line" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }